/* eslint-disable react/no-multi-comp */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import DataProvider from 'api/data-provider';
import { UserProp } from 'auth';

import Vote from './vote';

class VoteBlock extends PureComponent {
  static propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({})),
    auth: UserProp,
    forumType: PropTypes.string,
    actionDoLogin: PropTypes.func
  };

  render() {
    const { auth = {}, data = [], forumType = null, actionDoLogin } = this.props;
    if (!data.length) return null;

    return (
      <Vote
        forumType={forumType}
        auth={auth}
        data={data}
        actionDoLogin={actionDoLogin}
      />
    );
  }
}

export default class VoteProvider extends PureComponent {
  static propTypes = {
    topicId: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]),
    forumType: PropTypes.string,
    preloaded: PropTypes.shape({}),
    auth: UserProp,
    actionDoLogin: PropTypes.func
  };

  render() {
    const { topicId, forumType, auth, preloaded, actionDoLogin } = this.props;

    return (
      <DataProvider
        url="forum/question"
        updateEvent="updateVote"
        query={{
          'topic-id': topicId,
          date_off: true
        }}
        preloaded={preloaded}
      >
        <VoteBlock forumType={forumType} auth={auth} actionDoLogin={actionDoLogin} />
      </DataProvider>
    );
  }
}
